/*
 * vv-enhancements.js — Vortex Vitality DOM tweaks that CSS cannot express.
 *
 * Runs on EVERY viewport. It began life as vv-mobile.js, gated to phones, but
 * the bold colour name was later wanted on desktop too, so the breakpoint gate
 * was removed and the file renamed to stop the name lying about what it does.
 * (assets/vv-mobile.js is the orphaned original — unreferenced, safe to delete.)
 *
 * Only for things CSS genuinely cannot do. If a change can be made in
 * vv-mobile.css or vv-desktop.css, it belongs there — this costs a request on
 * every page.
 *
 * Because it is NOT breakpoint-gated, anything added here reaches desktop.
 * tools/check-desktop-untouched.js reports this file as a declared desktop
 * change; keep it to the one job below.
 *
 * Loaded from snippets/scripts.liquid.
 */
(function () {
  /*
   * Product titles read "Vprobe WiFi Smart Plant Sensor – Shady Green". The
   * design wants the colour name bold, but the title is a single text node with
   * no element around the colour, so there is nothing for CSS to select — the
   * markup has to be created. <strong> is bold by default, so no companion CSS
   * rule is strictly required.
   *
   * The theme's own product-title-truncation.js only sets line-clamp styles and
   * never rewrites text, so it does not fight this.
   */
  var SEPARATORS = ['–', '—', ' - ']; // en dash, em dash, spaced hyphen
  var SELECTORS = [
    'product-card [class*="__product_title_"] p', // collection / search cards
    '[class*="__text_xrnftG"] h3',                // product page title block
  ];
  var FLAG = 'vvColourBold';

  /** Index just past the first separator found, or -1. */
  function splitIndex(text) {
    for (var i = 0; i < SEPARATORS.length; i++) {
      var idx = text.indexOf(SEPARATORS[i]);
      if (idx !== -1) return idx + SEPARATORS[i].length;
    }
    return -1;
  }

  function decorate() {
    var nodes = document.querySelectorAll(SELECTORS.join(', '));
    for (var i = 0; i < nodes.length; i++) {
      var p = nodes[i];
      // Idempotent: the flag is what stops the MutationObserver below from
      // reacting to this function's own edits forever.
      if (p.dataset[FLAG]) continue;

      var text = p.textContent;
      var cut = splitIndex(text);
      var colour = cut === -1 ? '' : text.slice(cut).trim();

      // A title with no separator is left exactly as it is, rather than guessing
      // which trailing words are a colour.
      if (!colour) { p.dataset[FLAG] = 'none'; continue; }

      p.textContent = text.slice(0, cut) + ' ';
      var strong = document.createElement('strong');
      strong.textContent = colour;
      p.appendChild(strong);
      p.dataset[FLAG] = '1';
    }
  }

  function boot() {
    decorate();
    // Cards are re-rendered on filtering, pagination and section reloads, so new
    // ones arrive after first paint and need the same treatment.
    new MutationObserver(decorate).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
